import { useStore } from "..";
export const useGroupQuota = () => useStore(({ groupQuota }) => groupQuota);
